// Calendar days as `YYYY-MM-DD` strings, in the BROWSER's own zone.
//
// The server never decides which day it is — it runs in UTC, and a dinner
// logged at 20:00 in Mexico City is already tomorrow there. So "today" is
// computed here, from local fields, and handed to the api as a plain string.
// `toISOString()` is deliberately absent from this file: it renders the UTC
// day, which is yesterday or tomorrow for a good part of every day anywhere
// but Greenwich.

const pad = (n) => String(n).padStart(2, "0");

export const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

// A Date's LOCAL day.
export const toDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const today = (now = new Date()) => toDay(now);

// Local noon of a day, so adding days never crosses a DST edge into the
// neighbouring date — midnight plus 24 hours is 23:00 on the day a clock goes
// back.
const noon = (day) => {
  const [y, m, d] = day.split("-").map(Number);
  return new Date(y, m - 1, d, 12);
};

export const isDay = (value) =>
  typeof value === "string" && DATE_RE.test(value) && toDay(noon(value)) === value;

export const addDays = (day, n) => {
  const d = noon(day);
  d.setDate(d.getDate() + n);
  return toDay(d);
};

// "Thursday, 23 October" — or Today / Yesterday, which is what a person
// actually calls the two days they look at most.
export const dayLabel = (day, now = new Date()) => {
  const current = today(now);
  if (day === current) return "Today";
  if (day === addDays(current, -1)) return "Yesterday";
  if (day === addDays(current, 1)) return "Tomorrow";
  return noon(day).toLocaleDateString([], { weekday: "long", day: "numeric", month: "long" });
};

// "Thu" — the week strip's column header.
export const weekdayShort = (day) => noon(day).toLocaleDateString([], { weekday: "short" });
